<template>
  <form @submit.prevent="search" @reset.prevent="resetForm">
    <b-row>
      <b-col md="3" class="mt-2">
        <label class="label-text">User</label>
        <user-search-select
          :value="selectedUserObj"
          @input="handleUserChange"
        />
      </b-col>

      <b-col md="3" class="mt-2">
        <label class="label-text">Path</label>
        <b-input v-model="filter.path" type="text"></b-input>
      </b-col>

      <b-col md="3" class="mt-2">
        <label class="label-text">{{ $t('STATUS') }}</label>
        <b-select
          v-model="filter.status"
          :options="statusList"
          value-field="id"
          text-field="text"
        ></b-select>
      </b-col>

      <b-col md="3" class="mt-2">
        <label class="label-text">Date</label>
        <date-picker :value="filter.date" @change="dateReceptRequestFrom"></date-picker>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col class="d-inline-flex">
        <app-submit
          :disabled="loading"
          :loading="loader_submit"
          class="mr-3"
          variant="primary"
          button_type="search"
        >
          {{ $t('SEARCH') }}
        </app-submit>

        <app-submit
          :disabled="loading"
          :loading="loader_reset"
          variant="outline-primary"
          type="reset"
          button_type="reset"
        >
          {{ $t('RESET') }}
        </app-submit>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import DatePicker from '@/components/app/datetime/DatePicker'
import AppSubmit from "@/components/app/AppSubmit";
import { USER_DATA } from "@/shared/constants";
import UserSearchSelect from "@/components/user/UserSearchSelect.vue";

export default {
  name: "ApiLogFilter",
  components: {
    UserSearchSelect,
    AppSubmit,
    DatePicker
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loader_submit: false,
      loader_reset: false,
      reset_filter: false,

      statusList: [
        { id: 'success', text: 'Success' },
        { id: 'failed', text: 'Failed' }
      ],
      selectedUserObj: { id: null, name: null },
      filter: {
        user: null,
        path: null,
        status: null,
        date: null
      }
    }
  },
  computed: {
    userData() {
      return JSON.parse(localStorage.getItem(USER_DATA))
    },
  },
  methods: {
    handleUserChange(user) {
      this.selectedUserObj = user;
      this.filter.user = user ? user.id : null;
    },
    dateReceptRequestFrom(val) {
      this.filter.date = val;
    },

    search() {
      this.reset_filter = false;
      this.$emit('search', { ...this.filter });
    },

    resetForm() {
      this.reset_filter = true;
      this.selectedUserObj = { id: null, name: null };
      this.filter.user = null;
      this.filter.path = null;
      this.filter.status = null;
      this.filter.date = null;

      this.$emit('search', this.filter);
    }
  },
  watch: {
    loading(value) {
      if (this.reset_filter) {
        this.loader_reset = value;
        if (!value) this.reset_filter = false;
      } else {
        this.loader_submit = value;
      }
    }
  }
}
</script>

<style scoped>
.label-text {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5e6278;
  font-weight: 700;
  display: block;
  margin-bottom: 4px;
}
.card {
  border: none;
  box-shadow: 0 0 20px 0 rgba(76, 87, 125, 0.02);
}
</style>
